/** Billing product types stored on users.product_type. */

export const PART_TIME_PRODUCT_TYPE = 'keyflo_tc_free_monthly';
export const FULL_TIME_PRODUCT_TYPE = 'keyflo_tc_low_monthly';
export const LEGACY_PRODUCT_TYPE = 'keyflo_tc_standard';

export const PRODUCT_TYPES = [
  {
    value: PART_TIME_PRODUCT_TYPE,
    label: 'Part-Time Agent',
    hasFormGeneration: false,
    monthlyFeeCents: 0,
  },
  {
    value: FULL_TIME_PRODUCT_TYPE,
    label: 'Full-Time Agent',
    hasFormGeneration: true,
    monthlyFeeCents: 5000,
  },
  {
    value: LEGACY_PRODUCT_TYPE,
    label: 'KeyFlo TC',
    hasFormGeneration: true,
    monthlyFeeCents: 5000,
  },
];

const PRODUCT_TYPE_BY_VALUE = Object.fromEntries(
  PRODUCT_TYPES.map((product) => [product.value, product]),
);

export function productTypeOptions(currentValue) {
  const options = PRODUCT_TYPES.map((product) => ({
    value: product.value,
    label: `${product.label} (${product.value})`,
  }));
  const value = String(currentValue || '').trim();
  if (value && !PRODUCT_TYPE_BY_VALUE[value]) {
    options.push({ value, label: value });
  }
  return options;
}

export function productTypeMeta(productType) {
  return PRODUCT_TYPE_BY_VALUE[String(productType || '').trim()] || null;
}

export function planDisplayName(productType, { productDisplay, plans } = {}) {
  const display = String(productDisplay || '').trim();
  if (display) return display;
  const fromPlans = (plans || []).find((plan) => plan.product_type === productType);
  if (fromPlans?.display_name) return fromPlans.display_name;
  return productTypeMeta(productType)?.label || null;
}
